<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" :data="escrowSupportsList.beanList" height="100%" row-key="code">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="SDK代号" align="center" prop="code"/>
                <el-table-column label="SDK" align="center" prop="name"/>
                <el-table-column label="状态" align="center" width="250">
                    <template slot-scope="scope">
                        <el-switch
                                @change="statusChange(scope.row,$event)"
                                :value="scope.row.status"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="使用中"
                                inactive-text="未使用"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="escrowSupportsList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>启用该渠道</h3>
                <el-form>
                    <table class="common-popup-table">
                        <tr>
                            <td>账号：</td>
                            <td>
                                <el-input v-model="account" size="small"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>密码：</td>
                            <td>
                                <el-input v-model="password" type="password" size="small"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>验证码：</td>
                            <td>
                                <el-input v-model="smsCode" class="code" size="small"></el-input>
                                <btn-countdown
                                        @my-click="sendCodeToMyPhone({err:$event.err,type:6})"
                                        size="small"
                                        text="获取验证码"/>
                            </td>
                        </tr>
                    </table>
                </el-form>
                <footer>
                    <el-button size="small" @click="closeStatusChange">取消</el-button>
                    <el-button size="small" @click="submitStatusChange" type="primary">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import btnCountdown from 'components/btnCountdown'

    export default {
        components: {
            btnCountdown,
        },
        data() {
            return {
                loading: false,
                show: false,
                currentPage: 1,
                code: '',
                status: '',
                account: '',
                password: '',
                smsCode: ''
            }
        },
        computed: {
            ...mapState('escrowSupports', ['escrowSupportsList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('other',['sendCodeToMyPhone']),
            ...mapActions('escrowSupports', ['getEscrowSupportsList', 'updateStatus']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getEscrowSupportsList({page}).then(() => {
                    this.loading = false
                })
            },
            statusChange(row, value) {
                this.show = true;
                this.code = row.code;
                this.status = value
            },
            submitStatusChange() {
                this.updateStatus({
                    code: this.code,
                    status: this.status,
                    account: this.account,
                    password: window.btoa(this.password),
                    smsCode: this.smsCode
                }).then(() => {
                    this.getList(this.currentPage);
                    this.closeStatusChange();
                })
            },
            closeStatusChange() {
                this.show = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        height: 40px;
        line-height: 40px;
        font-weight: bold;
    }

    .code {
        width: 150px;
        margin-right: 10px;
    }
</style>